var localizationSupport = {
	notAvailable: "—",
	notDefined: ""
};
var localizationSupportTranslationsEs = {
	localizationSupport: localizationSupport
};

export { localizationSupportTranslationsEs as default, localizationSupport };
